import { Box, Checkbox, FormControl, FormHelperText, Grid, IconButton, InputLabel, ListItemText, MenuItem, Select, Tooltip } from '@mui/material';
import DateRange from 'src/components/common/DateRange';
import React, { Component } from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
import goodalipi from 'src/plugins/goodalipi';
import ClearIcon from '@mui/icons-material/Clear';
class AhcMisToolbar extends Component {
  constructor(props) {
    super(props);
    this.state = this.props.filter
    this.globalHR = goodalipi.get('globalHR');
    
  }
  handleChange(type, value) {
    let { dateRange, location, campus, bene, entityRequested,statusId,payment } = this.setState
    switch (type) {
      case 'dateRange':
        dateRange = value
        break
      case 'location':
        location = value
        break
      case 'campus':
        campus = value
        break
      case 'bene':
        bene = value
        break
      case 'entityRequested':
        entityRequested = value
        break;
      case 'statusId':
        statusId = value
        break;
      case 'payment':
        payment = value;
        break;
    }
    let obj = {}
    if (location) {
      obj.location = location
    }
    if (dateRange) {
      obj.dateRange = dateRange
    }
    if (campus) {
      obj.campus = campus
    }
    if (bene) {
      obj.bene = bene
    }
    if(entityRequested){
      obj.entityRequested = entityRequested
    }
    if(statusId){
      obj.statusId = statusId;
    }
    if (payment) {
      obj.payment = payment;
    }
    this.setState(obj, () => {
      this.props.setFilters(this.state)
    })
  }
  renderLabel(selected) {
    let arr = [];
    selected.forEach(each => {
      this.props.filterOptions.locationList.forEach(element => {
        if(element.val == each) {
          arr.push(element.key.toString());
        }
      });  
    });
    return arr.join(", ");
  }
  render() {
    return (
      <Box {...this.props}>
        <Grid direction="row" container spacing={3} sx = {{py : '8px'}}>
          <Grid item xs={12} sm={1.8}>
            <FormControl size='small' fullWidth variant="outlined">
              <InputLabel>Location</InputLabel>
              <Select
                multiple
                value={this.state.location}
                onChange={(ev) => { this.handleChange('location', ev.target.value) }}
                renderValue={(selected) => this.renderLabel(selected)}
                label="Location"
              >
                {
                  this.props.filterOptions.locationList.map((val, idx) => (
                    <MenuItem sx={{ py: 0 }} value={val.val} key={idx}>
                      <Checkbox
                        color="primary"
                        size="small" checked={this.state.location.length && this.state.location.indexOf(val.val) > -1} />
                      <ListItemText primary={val.key} />
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>

          {this.globalHR && (
          <Grid item xs={12} sm={1.3}>
            <FormControl size="small" fullWidth variant="outlined">
              <InputLabel>Entity Name</InputLabel>
              <Select
                // multiple
                value={this.state.entityRequested}
                onChange={(ev) => {
                  this.handleChange('entityRequested', ev.target.value);
                }}
                // renderValue={(selected) => selected.join(', ')}
                label="EntityId"
              >
                {this.props.filterOptions.entityRequested.map((val, idx) => (
                  <MenuItem sx={{ py: 0 }} value={val.val} key={idx}>
                    <ListItemText primary={val.key} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}


          <Grid item xs={12} sm={1.5}>
            <FormControl size='small' fullWidth variant="outlined">
              <InputLabel>Provider</InputLabel>
              <Select
                multiple
                value={this.state.campus}
                onChange={(ev) => { this.handleChange('campus', ev.target.value) }}
                renderValue={(selected) => selected.join(', ')}
                label="campus"
              >
                {
                  this.props.filterOptions.campusList.map((val, idx) => (
                    <MenuItem sx={{ py: 0 }} value={val} key={idx}>
                      <Checkbox
                        color="primary"
                        size="small" checked={this.state.campus.length && this.state.campus.indexOf(val) > -1} />
                      <ListItemText primary={val} />
                    </MenuItem>
                  ))
                }
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={1.5}>
              <FormControl size='small' fullWidth variant="outlined">
                <InputLabel>Beneficiary</InputLabel>
                <Select
                  multiple
                  value={this.state.bene}
                  onChange={(ev) => { this.handleChange('bene', ev.target.value) }}
                  renderValue={(selected) => selected.join(', ')}
                  label="Beneficiary"
                >
                  {
                    this.props.filterOptions.beneList.map((val, idx) => (
                      <MenuItem sx={{ py: 0 }} value={val} key={idx}>
                        <Checkbox
                          color="primary"
                          size="small" checked={this.state.bene.length && this.state.bene.indexOf(val) > -1} />
                        <ListItemText primary={val} />
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
          </Grid>
          <Grid item xs={12} sm={1.5}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel>Status</InputLabel>
            <Select
              // multiple
              value={this.state.statusId}
              onChange={(ev) => {
                this.handleChange('statusId', ev.target.value);
              }}
              // renderValue={(selected) => selected.join(', ')}
              label="payment"
            >
              {this.props.filterOptions.statusId.map((val, idx) => (
                <MenuItem sx={{ py: 0 }} value={val} key={idx}>
                  <ListItemText primary={val} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
          <Grid item xs={12} sm={1.8}>
          <FormControl size="small" fullWidth variant="outlined">
            <InputLabel>Payment Type</InputLabel>
            <Select
              // multiple
              value={this.state.payment}
              onChange={(ev) => {
                this.handleChange('payment', ev.target.value);
              }}
              label="payment"
            >
              {this.props.filterOptions.paymentList.map((val, idx) => (
                <MenuItem sx={{ py: 0 }} value={val} key={idx}>
                  <ListItemText primary={val} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={3}>
        <DateRange
          helperTextValue={'Created Date'}
          boxsize="small"
          onDateChange={(value) => {
            this.handleChange('dateRange',value);
          }}
        />
      </Grid>
       
        <Grid item sx={{ width: '50px', marginLeft: '10px' }}>
          <Tooltip title="Refresh">
            <IconButton
              size="small"
              sx={{ bgcolor: 'white', boxShadow: '0 0 4px rgba(0,0,0,0.20)' }}
              onClick={() => this.props.onRefresh()}
              color="primary"
              aria-label="refresh"
            >
              <Refresh />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid
          item
          sx={{ width: '70px', marginTop: '-15px' }}
          container
          alignContent="center"
          justifyItems="center"
        >
          <Tooltip title="Reset">
            <IconButton
              sx={{
                bgcolor: 'white',
                boxShadow: '0 0 4px rgba(0,0,0,0.31)'
              }}
              color="primary"
              size="small"
              onClick={() => window.location.reload()}
            >
              <ClearIcon color="primary" />
            </IconButton>
          </Tooltip>
        </Grid>

        </Grid>

      </Box>
    )
  }
}

export default AhcMisToolbar
